import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Divider from '@material-ui/core/Divider';

interface Props {
  open: boolean;
  listIndex: number;
  onDelete: (index: number) => void;
  onCancel: () => void;
}

function PersonsListByDateDeleteConfirmation({ open, listIndex, onDelete, onCancel }: Props) {
  const classes = useStyles();

  return (
    <Dialog open={open}>
      <div className={classes.root}>
        <Typography className={classes.text}>
          If you delete this list, you will lose all of your saved settings. Do you want to
          continue?
        </Typography>
        <Divider variant="fullWidth" className={classes.divider} />
        <div className={classes.buttonContainer}>
          <Button className={classes.button} onClick={onCancel}>
            Cancel
          </Button>
          <Button className={classes.button} onClick={() => onDelete(listIndex)} color="secondary">
            Delete
          </Button>
        </div>
      </div>
    </Dialog>
  );
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 402,
    maxHeight: 130,
    paddingTop: theme.spacing(1.5),
  },
  text: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    marginBottom: theme.spacing(2.5),
    maxHeight: 48,
  },
  buttonContainer: {
    marginLeft: 'auto',
    marginTop: theme.spacing(1.5),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(1.5),
    maxHeight: 48,
  },
  button: {
    maxHeight: 24,
  },
  divider: {
    margin: 0,
    backgroundColor: theme.palette.common.black,
  },
}));

export default PersonsListByDateDeleteConfirmation;
